

$(window).on("load", function () {
	
});
